<template>
  <div id="sys-login">
    <div class="login-header">
      <div class="header-icon">
          <img style="width:92px" src="../assets/images/default/hy-login-icon.png" alt="">
      </div>
      <p class="login-hy-name">华医云动态心电血压后台管理系统</p>
    </div>
    <div class="login-body">
      <div class="login-box">
          <div class="login-user">
            <span class="login-user-enter">登录</span>
          </div>
          <el-form  ref="loginForm" :rules="loginRules" :model="loginForm" class="login-from">
            <el-form-item  prop="username" style="textAlign:center">
                <el-input v-model="loginForm.username" autofocus placeholder="请输入用户名" class="username">
                  <i slot="prefix" class="el-input__icon hy-icon-user"></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="password" style="textAlign:center">
                <el-input v-model="loginForm.password" placeholder="请输入密码" @keyup.enter.native="submint()"  type="password" class="password">
                    <i slot="prefix" class="el-input__icon hy-icon-password"></i>
                </el-input>
            </el-form-item>
            <el-form-item v-show="flag">
              <div style="textAlign:left;display:flex;justify-content:center;width:100%" >
                <el-input v-model="loginForm.code" placeholder="输入验证码" ref='code' @keyup.enter.native="submint()" type="text" class="code">
                  <i slot="prefix" class="el-input__icon hy-icon-password"></i>
                </el-input>
                <!-- <span class="yzCode" id='v_container'></span> -->
                <img :src="imgSrc" alt="" @click='refresh()' id="imgCode">
              </div>
            </el-form-item>
            <el-form-item style="textAlign:center">
                <el-button type="primary" round style="width:339px;margin:20px auto;fontSize:18px;" @keyup.enter.native="submint()" @click="submint()">登   录</el-button>
            </el-form-item>
          </el-form>
      </div>
    </div>
    <div class="login-footer">
        <!-- <p>项目介绍<span class="login-segmentation">|</span>关于我们<span class="login-segmentation">|</span>使用协议<span class="login-segmentation">|</span>使用帮助<span class="login-segmentation">|</span>意见反馈</p> -->
        <p class="copy-right">Copyright © 2016-2018<span class="login-segmentation">|</span>京ICP备17065707号-1</p>
        <p >北京华医共享医疗科技有限公司</p>
    </div>
    <!-- <div class="title_right">围场专版</div> -->
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Loading } from 'element-ui'
export default {
    name :"login",
    data(){
        return {
            imgSrc:this.$domain.getImageCode,
            loginForm:{
                username:"",
                password:"",
                code:'',
            }, 
            loginRules: {
                    username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    ],
                    password :[
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ]
                },
            sysMsg: '',
            checked:false,
            loadingInstance:'',
            flag:true,
        }
    },
    mounted() {
      window.sessionStorage.setItem('userId','');
    },
    methods:{
        //图形验证码刷新
        refresh(){
            var num=Math.ceil(Math.random()*10);//生成一个随机数（防止缓存）
            this.imgSrc=this.$domain.getImageCode+'?'+num
        },
        //获取是否显示图形验证码的状态
        init(){
            if(this.loginForm.username==''){
                return;
            }
            this.$ajax.post(this.$domain.getImgCodeState,{
                username:this.loginForm.username
            })
            .then(ret=>{
                console.log(ret.data)
                if(ret.data.data=='false'){
                    this.flag=false;
                }
                else{
                    this.flag=true;
                }
            })
        },
        submint(){
            this.$refs['loginForm'].validate((valid) => {
                if (valid) {
                    if(this.loginForm.password.length<6){
                        this.$message.error('密码不得少于六位！');
                        return;
                    }
                    if(this.flag&&this.loginForm.code==''){
                      this.$message.error('请输入图形验证码！');
                      return;
                    }
                    this.loadingInstance=Loading.service({
                        text:'登录中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    let password=this.$common.Encrypt(this.$common.pwd99(this.loginForm.password));
                    let obj='';
                    if(this.flag){
                      obj={
                        username:this.loginForm.username,
                        password:password,
                        imageCode:this.loginForm.code
                      }
                    }
                    else{
                      obj={
                        username:this.loginForm.username,
                        password:password
                      }
                    }
                    this.$ajax.post(this.$domain.login,obj)
                    .then(ret=>{
                        this.loadingInstance.close();
                        console.log(ret.data);
                        if(ret.data.code==10){
                            this.$common.setStorage('loginId',ret.data.data.loginId);
                            this.$common.setStorage('loginMsg',ret.data.data);
                            if(ret.data.data.userRoleList.indexOf("finance")>-1){
                                this.$router.push({path:'/finance'});
                                return;
                            }                       
                            this.$router.push({path:'/hospManage'});
                        }
                        else{
                            // this.$message.error('服务器错误,错误码：'+ret.data.code);
                            this.$message.error(ret.data.message);
                            this.flag=true;
                            this.refresh();
                        }
                    })
                    .catch(err=>{
                      console.log(err)
                        this.loadingInstance.close();
                    })
                    
                }
            });
          
        }
  }
}
</script>
<style lang="scss">

#sys-login{
  width: 100%;
  min-height:800px;
  height:100%;
  position: relative;
  .login-header{
      width: 100%;
      height: 138px;
      background-color: #fff;
      overflow: hidden;
      .header-icon{
        width: 92px;
        height: 107px;
        float: left;
        margin-left: 11%;
        margin-top: 16px;  
      }
      .login-hy-name{
        font-size: 42px;
        color: #5c6bc0;
        float: left;
        height: 107px;
        line-height: 107px;
        margin-left: 40px;
        margin-top: 20px;
      }
      .login-service-tel{
        font-size: 24px;
        color: #5b5b5b;
        float: right;
        margin-right: 18%;
        margin-top: 53px;
        .login-service-tel-call{
          margin-bottom: 5px;
          text-align: center;
        }
        .login-service-tel-detail{
        letter-spacing: 1px;
        }
      }
  }
  .login-body{
    width: 100%;
    background-image: url('../assets/images/default/hy-bg-img.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    min-width: 1200px;
    position: absolute;
    top: 140px;
    bottom: 150px;
    .login-box{
      width: 400px;
      height: 460px;
      background-color: #fff;
      position: absolute;
      box-shadow:0px 0px 10px 5px #5c6bc0;
      top: 50%;
      transform: translate(0,-50%);
      right: 20%;
      border-radius: 10px;
      .login-user {
        width: 100%;
        margin-top: 30px;
        overflow: hidden;
        padding-bottom: 14px;
        .login-user-enter{
          font-size: 28px;
          color: #333;
          display: inline-block;
          width:100%;
          text-align: center;
        }
        .user-login{
          font-size: 14px;
          color: #bfbfbf;
          float: left;
          margin-top: 12px;
          margin-left: 16px;
           
        }
      }
      .login-from{
        .el-form-item__error{
            padding-left: 50px;
        } 
        .username{
          width: 339px;
          height: 49px;
          line-height: 49px;
          margin: 20px auto;
          border-bottom: 1px solid #c9c9c9;
          text-align: center;
          font-size: 15px;
           
          .el-input__inner{
            width: 330px;
             line-height: 49px;
             border: none;
                color: #333;
                padding-left: 54px;
          }
          .hy-icon-user{
            box-sizing: border-box;
            padding-left:40px;
            font-size: 20px;
            background-image: url('../assets/images/default/hy-icon-user.png');
            background-repeat: no-repeat;
            background-size: auto;
            background-position-x: 10px;
      
               }
          }
          .password{
            width: 339px;
            height: 49px;
            line-height: 49px;
            border-bottom: 1px solid #c9c9c9;
            color: #333;
            font-size: 15px;
            margin: 0px auto 20px;
            .hy-icon-password{
              box-sizing: border-box;
              padding-left:40px;
              font-size: 20px;
              background-image: url('../assets/images/default/hy-icon-password.png');
              background-repeat: no-repeat;
              background-size: auto;
              background-position-x: 10px;
      
            }
            .el-input__inner{
              width: 330px;
              line-height: 49px;
              border: none;
                  color: #333;
                  padding-left: 54px;
            }
          }
          .code{
            width: 215px;
            height: 49px;
            line-height: 49px;
            border-bottom: 1px solid #c9c9c9;
            color: #333;
            font-size: 15px;
            .hy-icon-password{
              box-sizing: border-box;
              padding-left:40px;
              font-size: 20px;
              background-image: url('../assets/images/default/hy-icon-code.png');
              background-repeat: no-repeat;
              background-size: auto;
              background-position-x: 10px;
      
            }
            .el-form-item__content{
              margin:0!important;
              margin-left:65px;
            }
            .el-input__inner{
              width: 215px;
              line-height: 49px;
              border: none;
                  color: #333;
                  padding-left: 54px;
            }
          }
          #imgCode{
            display:inline-block;
            width:100px;
            height:49px;
            margin-left:20px;
          }
        .forget-password {
          color: #FF840C;
          font-size: 14px;
          position: absolute;
          right: 0;
          text-decoration: none;
        }
      }
    }
  }
  .login-footer{
    margin-top: 79px;
    font-size: 12px;
    color: #5c6bc0;
    text-align: center;
    position: absolute;
    bottom: 50px;
    width: 100%;
    .login-segmentation{
      margin-left: 5px;
      margin-right: 5px;
    }
    .copy-right{
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }
  
  .title_right{
    width:100px;
    background-color:#777;
    position:absolute; top:10px; right:10px; z-index:5;
    color:#fff; font-size: 16px; line-height: 30px;
    text-align: center;
    border-radius: 8px;
  }
}

.el-form-item__content{
  text-align: center;
  margin: 0 auto
}
</style>



// WEBPACK FOOTER //
// src/page/login.vue